import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MicVolumeService } from "./services";

@NgModule({
  imports: [CommonModule],
  providers: [MicVolumeService]
})
export class MicVolumeDataAccessModule {}
